import api from "./api";

// Capa de servicios API del dominio "queue-options" (opciones de chatbot por cola).
export const listQueueOptions = (params) =>
  api.get("/queue-options", { params });
export const createQueueOption = (payload) =>
  api.post("/queue-options", payload);
export const updateQueueOption = (optionId, payload) =>
  api.put(`/queue-options/${optionId}`, payload);
export const deleteQueueOption = (optionId) =>
  api.delete(`/queue-options/${optionId}`);
